import React, { Component } from 'react';
import autobind from 'react-autobind';
import { Row, Col } from 'antd';
import translate from 'app/translations';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import ApplicationList from './components/ApplicationList';
import ApplicationsDashboardPropType from './ApplicationsDashboardPropType';
import {
  fetchConstantsRequest,
  fetchApplicationListRequest,
  fetchRegionsByNameRequest,
} from './applicationsDashboardActions';

export class ApplicationsDashboard extends Component {
  constructor(props) {
    super(props);
    autobind(this);
    this.t = translate;
  }

  componentDidMount() {
    this.props.fetchConstantsRequest();
  }

  render() {
    const { dashboard, app } = this.props;

    return (
      <div className="agent-profile card-container box-shadow">
        <Row type="flex" justify="center">
          <Col xs={24} md={20} lg={16} xl={16}>
            <div>
              <ApplicationList
                dashboard={dashboard}
                onFetchApplicationListRequest={this.props.fetchApplicationListRequest}
                onFetchRegionsByNameRequest={this.props.fetchRegionsByNameRequest}
                app={app}
              />
            </div>
          </Col>
        </Row>
      </div>
    );
  }
}

ApplicationsDashboard.propTypes = {
  dashboard: PropTypes.shape(ApplicationsDashboardPropType).isRequired,
  fetchApplicationListRequest: PropTypes.func.isRequired,
  fetchConstantsRequest: PropTypes.func.isRequired,
  fetchRegionsByNameRequest: PropTypes.func.isRequired,
  app: PropTypes.shape({}).isRequired,
};

const mapStateToProps = state => ({
  dashboard: state.dashboard,
  app: state.app,
});

const mapDispatchToProps = dispatch => bindActionCreators(
  {
    fetchApplicationListRequest,
    fetchConstantsRequest,
    fetchRegionsByNameRequest,
  },
  dispatch,
);

export default connect(mapStateToProps, mapDispatchToProps)(ApplicationsDashboard);

